module.exports = __webpack_public_path__ + "img/img12.0840ae5f.svg";